import Immutable from 'immutable';
import { createSelector } from 'reselect';

const accountMessagesStatus = state => state.getIn(['ui', 'accountMessages'], Immutable.Map());

export const getAccountMessagesStatus = createSelector(
  [accountMessagesStatus],
  (status) => status
);

export default {
  getAccountMessagesStatus
};



// WEBPACK FOOTER //
// ./app/selectors/AccountMessagesSelector.js